
import { Grid, Container,} from '@mui/material';
// import { useTheme } from '@mui/material/styles';

import useSettings from '../../hooks/useSettings';

import Page from '../../components/Page';

import AllApplications from '../../sections/tables/AllApplications';



// ----------------------------------------------------------------------

export default function Applications() {
  const { themeStretch } = useSettings();
//   const theme = useTheme();





  return (
    <Page title="Dashboard Application">
      <Container maxWidth={themeStretch ? false : 'xl'}>
    
         
       
        <Grid container spacing={3}>
        <Grid item xs={12} md={12} lg={12}>
          <AllApplications />
          </Grid>
          </Grid>
      </Container>
    </Page>
  );
}
